import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00cf8302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-bar" }
const _hoisted_2 = { class: "side-bar__content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "side-bar__content__title no-squares-message" }, "Squares that you select on the board will be displayed here", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "side-bar__content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "side-bar__content__title" }, "Selected Squares", -1))
const _hoisted_8 = { class: "side-bar__controls" }
const _hoisted_9 = { class: "side-bar__controls__control" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Theme", -1))
const _hoisted_11 = { class: "side-bar__controls__control" }

import { computed } from 'vue';
import {useStore} from 'vuex';

import SquareTag from './SquareTag.vue';

import AppButton from '@/components/ui/AppButton.vue';
import ThemeSlider from '@/components/ui/ThemeSlider.vue';
import { getRank, getFile } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
    theme: {},
    toggleTheme: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const selectedSquares = computed(() => store.state.squares);
const selectedSquaresCount = computed(() => selectedSquares.value.length);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (selectedSquaresCount.value === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSquares.value, (selectedSquare, index) => {
              return (_openBlock(), _createBlock(SquareTag, {
                key: selectedSquare,
                onClick: () => _unref(store).commit('removeSquare', selectedSquare)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(_unref(getFile)(selectedSquare - 1)) + _toDisplayString(_unref(getRank)(selectedSquare - 1)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(ThemeSlider, {
          theme: props.theme,
          toggleTheme: props.toggleTheme
        }, null, 8, ["theme", "toggleTheme"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(AppButton, {
          onClick: _cache[0] || (_cache[0] = () => _unref(store).commit('clearSquares')),
          disabled: selectedSquaresCount.value === 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Clear ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})